import { SEO } from "@/components/SEO";
import { SiteLayout } from "@/components/site/SiteLayout";
import { CustomerJourneySection } from "@/components/site/CustomerJourneySection";

function SplitCheckoutHowItWorks() {
  return (
    <SiteLayout>
      <SEO
        title="How Splitkart Checkout Works"
        description="See the Splitkart customer journey from starting a split to completing payment with friends."
        url="/split-checkout-how-it-works"
      />

      <CustomerJourneySection pageHeading />
    </SiteLayout>
  );
}

export default SplitCheckoutHowItWorks;
